"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateCategoryCircuitDto = void 0;
class CreateCategoryCircuitDto {
    name;
    categoryIds;
    tagIds;
    displayIds;
    color;
    background;
    image;
    description;
    order;
    featured;
    is_archived;
}
exports.CreateCategoryCircuitDto = CreateCategoryCircuitDto;
